<template>
  <div id="tac-admin-dropship-sync-inventory__dashboard">
    <ol class="breadcrumb">
      <li><a href="/admin">Admin</a></li>
      <li><a href="/admin/dropship">Dashboard</a></li>
      <li><a href="/admin/dropship/supplier">Supplier</a></li>
      <li><router-link to="/admin/dropship/supplier/sync">Sync</router-link></li>
      <li class="active">Inventory</li>
    </ol>
    <div class="page-header">
      <h1 class="page-header-title">
        <span class="fa fa-fw fa-exchange"></span>
        Inventory Sync <small>Push supplier inventory to seller</small>
      </h1>
    </div><!-- .page-header -->
    <div class="page-body">
      <div class="row">
        <div class="col-lg-6">
          <by-product-form></by-product-form>
        </div>
      </div>
    </div><!-- .page-body -->
  </div><!-- #tac-admin-dropship-sync-inventory__dashboard -->
</template>

<script>
import ApiResponseMixin from '@/plugin/mixin/api-response'
import ByProductForm from './ByProductForm'

export default {
  created() {
    this.fetchOptions()
  },
  methods: {
    fetchOptions() {
      this.$store.dispatch('dropship/supplier/syncInventory/fetchOptions')
    },
    async syncAllSellers() {
      try {
        const response = await this.$store.dispatch('dropship/supplier/syncInventory/applyPayloadToAllSellers')
        if (response) {
          this.$alertify.success('Background task created')
        } else {
          this.$alertify.error('Background task NOT created')
        }
      } catch (reason) {
        if (this.isResponseError(reason)) {
          this.raiseErrorMessage(reason)
        } else {
          this.$alertify.error('An error was raised while requesting to apply payload to all sellers.  Message: ' + reason)
        }
      }
    }
  },
  components: {
    ByProductForm
  },
  mixins: [
    ApiResponseMixin
  ]
}
</script>
